import { render, staticRenderFns } from "./AmountForm.vue?vue&type=template&id=1fe52d34"
import script from "./AmountForm.vue?vue&type=script&lang=js"
export * from "./AmountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports